/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'double-chevron': {
    viewBox: '0 0 24 24',
    data: `<g data-name="pagination arrow"><polygon points="12.064 11.984 6.751 17.297 6 16.545 10.561 11.984 6 7.423 6.751 6.672 12.064 11.984" style="fill-rule:evenodd"/><polygon points="18 11.984 12.688 17.297 11.936 16.545 16.498 11.984 11.936 7.423 12.688 6.672 18 11.984" style="fill-rule:evenodd"/></g>`
  }
})
